// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemandApprovalPage {

    height: 90vh;
    overflow-x: hidden;
    overflow-y: scroll;
    scroll-behavior: smooth;

    .DemandElement {
        width: 100%;
        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;

            .part1 {
                font-size: 14px;
                border: 1px solid black;
            }


            .labelContianer {
                width: fit-content;

                label {
                    font-size: 14px;
                }
            }
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .shadowbox {
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 25px 15px;
        background-color: white;
    }



    .tableContainer {
        table {
            width: 100%;
            border: 1px solid #000000;
            border-collapse: 'collapse';
            text-align: 'center';
            border: '1px solid #1976d2';


            tr,
            th,
            td {
                padding: 10px;
                font-size: 1px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 16px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }

    .tableContainer1 {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #000000;


            tr,
            th,
            td {
                padding: 10px 0px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 10px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }

    .tableContainer2 {
        width: 100%;
        overflow-x: auto;
        border-radius: 8px;
        background-color: white;
        border: 1px solid #1976d2;
 
        table {
            width: 100%;
            border-collapse: collapse !important;
            border: 1px solid #AFD1F6 !important;
 
            tr,
            th,
            td {
                border: 1px solid #AFD1F6 !important;
            }
 
            thead {
                tr {
                    th {
                        font-weight: 500;
                    }
                }
            }
 
            tbody {
                tr:nth-child(odd) {
                    background-color: #E5F4FB;
                    border-bottom: 1px solid #AFD1F6 !important;
                }
 
                tr:nth-child(even) {
                    background-color: #CFE4F1;
                    border-bottom: 1px solid #AFD1F6 !important;
                }
 
                tr td {
                    font-weight: 400;
                    border-bottom: 1px solid #AFD1F6 !important;
                }
            }
 
        }
    }

    /* old code */
    /* .tableContainer2 {
        width: 100%;
        overflow-x: auto;
        border-radius: 8px;
        background-color: white;
        border: 1px solid #1976d2;

        table {
            width: 100%;
            border-collapse: collapse;

            thead {
                tr {
                    th {
                        font-weight: 500;
                    }
                }
            }

            tbody {
                tr {
                    background-color: #E0E6F4;

                    td {
                        font-weight: 400;
                    }
                }
            }

        }
    } */


    /* // Added New For border [table, thead, tbody] */
.demandApprovalPdfTable {
    width: 100%;
    overflow-x: auto;
    border: 1px solid #ccc;

    table {
        width: 100%;
        border-collapse: collapse !important;
        border-spacing: 0 !important;
        text-align: center;
        border: 1px solid #ccc !important;

        thead {
            tr {
                border: 1px solid #ccc !important;

                th {
                    border: 1px solid #ccc !important;
                    padding: 8px;
                }
            }
        }

        tbody {
            tr {
                border: 1px solid #ccc !important;

                td {
                    border: 1px solid #ccc !important;
                    padding: 6px;
                }
            }
        }
    }
}

}


.makeitlink {
    color: #4f46e5;
    text-decoration: underline;
    font-weight: 700;
    cursor: pointer;
}

.DistrictTableContianer {
    width: 80%;
    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);

    table {
        width: 100%;
        border-radius: 8;

        thead {

            th {
                padding: 10px 8px;
                background-color: #4f46e5;
                color: white;
                font-weight: 600;
                font-size: 15px;
                -webkit-user-select: none;
                        user-select: none;
            }
        }

        tbody {
            tr {
                td {

                    /* border: 1px solid #4f46e5 !important; */
                    padding: 12px 10px;
                    font-size: 14px;
                    color: #333
                }
            }
        }

    }
}


`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/DemandManagement/DemandApproval/DemandApproval.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;;IAEvB;QACI,WAAW;QACX,sDAAsD;QACtD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;;YAEhB;gBACI,eAAe;gBACf,uBAAuB;YAC3B;;;YAGA;gBACI,kBAAkB;;gBAElB;oBACI,eAAe;gBACnB;YACJ;QACJ;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;IAC3B;;;;IAIA;QACI;YACI,WAAW;YACX,yBAAyB;YACzB,2BAA2B;YAC3B,oBAAoB;YACpB,2BAA2B;;;YAG3B;;;gBAGI,aAAa;gBACb,cAAc;YAClB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,iBAAiB;YACrB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,yBAAyB;;QAEzB;YACI,WAAW;YACX,oCAAoC;YACpC,oCAAoC;;YAEpC;;;gBAGI,oCAAoC;YACxC;;YAEA;gBACI;oBACI;wBACI,gBAAgB;oBACpB;gBACJ;YACJ;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,2CAA2C;gBAC/C;;gBAEA;oBACI,yBAAyB;oBACzB,2CAA2C;gBAC/C;;gBAEA;oBACI,gBAAgB;oBAChB,2CAA2C;gBAC/C;YACJ;;QAEJ;IACJ;;IAEA,aAAa;IACb;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA8BG;;;IAGH,kDAAkD;AACtD;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;;IAEtB;QACI,WAAW;QACX,oCAAoC;QACpC,4BAA4B;QAC5B,kBAAkB;QAClB,iCAAiC;;QAEjC;YACI;gBACI,iCAAiC;;gBAEjC;oBACI,iCAAiC;oBACjC,YAAY;gBAChB;YACJ;QACJ;;QAEA;YACI;gBACI,iCAAiC;;gBAEjC;oBACI,iCAAiC;oBACjC,YAAY;gBAChB;YACJ;QACJ;IACJ;AACJ;;AAEA;;;AAGA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,+CAA+C;;IAE/C;QACI,WAAW;QACX,gBAAgB;;QAEhB;;YAEI;gBACI,iBAAiB;gBACjB,yBAAyB;gBACzB,YAAY;gBACZ,gBAAgB;gBAChB,eAAe;gBACf,yBAAiB;wBAAjB,iBAAiB;YACrB;QACJ;;QAEA;YACI;gBACI;;oBAEI,0CAA0C;oBAC1C,kBAAkB;oBAClB,eAAe;oBACf;gBACJ;YACJ;QACJ;;IAEJ;AACJ","sourcesContent":[".DemandApprovalPage {\n\n    height: 90vh;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    scroll-behavior: smooth;\n\n    .DemandElement {\n        width: 100%;\n        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */\n        border-radius: 5px;\n        padding: 20px 50px;\n        background-color: white;\n\n        label {\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n\n        .elements {\n            margin: 15px 0px;\n\n            .part1 {\n                font-size: 14px;\n                border: 1px solid black;\n            }\n\n\n            .labelContianer {\n                width: fit-content;\n\n                label {\n                    font-size: 14px;\n                }\n            }\n        }\n\n\n        textarea,\n        select,\n        input {\n            width: 100%;\n            border: 1px solid #505050;\n            padding: 5px 10px;\n            font-size: 16px;\n            font-weight: 400;\n            border-radius: 3px;\n        }\n\n        select {\n            font-size: 14px !important;\n            font-weight: 500 !important;\n            color: #817f7f;\n        }\n\n        select:focus {\n            color: black;\n        }\n\n        textarea {\n            height: 12vh;\n        }\n\n        ::placeholder {\n            color: #817f7f;\n        }\n    }\n\n    .shadowbox {\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\n        border-radius: 5px;\n        padding: 25px 15px;\n        background-color: white;\n    }\n\n\n\n    .tableContainer {\n        table {\n            width: 100%;\n            border: 1px solid #000000;\n            border-collapse: 'collapse';\n            text-align: 'center';\n            border: '1px solid #1976d2';\n\n\n            tr,\n            th,\n            td {\n                padding: 10px;\n                font-size: 1px;\n            }\n\n            tr,\n            th,\n            td {\n                border: 1px solid #000000 !important;\n                font-size: 16px;\n\n            }\n\n            thead {\n                tr {\n                    background-color: #0094DE;\n                    color: white;\n\n                    th {\n                        font-weight: 500 !important;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    /* border: 1px solid #000000 !important; */\n\n                    td {\n                        /* border: 1px solid #000000 !important; */\n                        font-weight: 400 !important;\n                    }\n\n                }\n            }\n\n        }\n    }\n\n    .tableContainer1 {\n        width: 100%;\n\n        table {\n            width: 100%;\n            border: 1px solid #000000;\n\n\n            tr,\n            th,\n            td {\n                padding: 10px 0px;\n            }\n\n            tr,\n            th,\n            td {\n                border: 1px solid #000000 !important;\n                font-size: 10px;\n\n            }\n\n            thead {\n                tr {\n                    background-color: #0094DE;\n                    color: white;\n\n                    th {\n                        font-weight: 500 !important;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    /* border: 1px solid #000000 !important; */\n\n                    td {\n                        /* border: 1px solid #000000 !important; */\n                        font-weight: 400 !important;\n                    }\n\n                }\n            }\n\n        }\n    }\n\n    .tableContainer2 {\n        width: 100%;\n        overflow-x: auto;\n        border-radius: 8px;\n        background-color: white;\n        border: 1px solid #1976d2;\n \n        table {\n            width: 100%;\n            border-collapse: collapse !important;\n            border: 1px solid #AFD1F6 !important;\n \n            tr,\n            th,\n            td {\n                border: 1px solid #AFD1F6 !important;\n            }\n \n            thead {\n                tr {\n                    th {\n                        font-weight: 500;\n                    }\n                }\n            }\n \n            tbody {\n                tr:nth-child(odd) {\n                    background-color: #E5F4FB;\n                    border-bottom: 1px solid #AFD1F6 !important;\n                }\n \n                tr:nth-child(even) {\n                    background-color: #CFE4F1;\n                    border-bottom: 1px solid #AFD1F6 !important;\n                }\n \n                tr td {\n                    font-weight: 400;\n                    border-bottom: 1px solid #AFD1F6 !important;\n                }\n            }\n \n        }\n    }\n\n    /* old code */\n    /* .tableContainer2 {\n        width: 100%;\n        overflow-x: auto;\n        border-radius: 8px;\n        background-color: white;\n        border: 1px solid #1976d2;\n\n        table {\n            width: 100%;\n            border-collapse: collapse;\n\n            thead {\n                tr {\n                    th {\n                        font-weight: 500;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    background-color: #E0E6F4;\n\n                    td {\n                        font-weight: 400;\n                    }\n                }\n            }\n\n        }\n    } */\n\n\n    /* // Added New For border [table, thead, tbody] */\n.demandApprovalPdfTable {\n    width: 100%;\n    overflow-x: auto;\n    border: 1px solid #ccc;\n\n    table {\n        width: 100%;\n        border-collapse: collapse !important;\n        border-spacing: 0 !important;\n        text-align: center;\n        border: 1px solid #ccc !important;\n\n        thead {\n            tr {\n                border: 1px solid #ccc !important;\n\n                th {\n                    border: 1px solid #ccc !important;\n                    padding: 8px;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                border: 1px solid #ccc !important;\n\n                td {\n                    border: 1px solid #ccc !important;\n                    padding: 6px;\n                }\n            }\n        }\n    }\n}\n\n}\n\n\n.makeitlink {\n    color: #4f46e5;\n    text-decoration: underline;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.DistrictTableContianer {\n    width: 80%;\n    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);\n\n    table {\n        width: 100%;\n        border-radius: 8;\n\n        thead {\n\n            th {\n                padding: 10px 8px;\n                background-color: #4f46e5;\n                color: white;\n                font-weight: 600;\n                font-size: 15px;\n                user-select: none;\n            }\n        }\n\n        tbody {\n            tr {\n                td {\n\n                    /* border: 1px solid #4f46e5 !important; */\n                    padding: 12px 10px;\n                    font-size: 14px;\n                    color: #333\n                }\n            }\n        }\n\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
